var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#1752AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0879 8.31055C13.8887 8.31055 14.5273 8.50391 15.0039 8.89062C15.4805 9.27734 15.7188 9.79297 15.7188 10.4375C15.7188 10.8711 15.6211 11.2422 15.4258 11.5508C15.2344 11.8555 14.8633 12.207 14.3125 12.6055C13.9336 12.8828 13.6953 13.0938 13.5977 13.2383C13.5 13.3828 13.4512 13.5723 13.4512 13.8066V14.1582H11.8984V13.7246C11.8984 13.3496 11.9785 13.0234 12.1387 12.7461C12.2988 12.4648 12.5879 12.1738 13.0059 11.873C13.4277 11.5684 13.7031 11.3262 13.832 11.1465C13.9609 10.9668 14.0254 10.7559 14.0254 10.5137C14.0254 10.2715 13.9316 10.084 13.7441 9.95117C13.5605 9.81836 13.2988 9.75195 12.959 9.75195C12.377 9.75195 11.709 9.94336 10.9551 10.3262L10.3164 9.04297C11.1914 8.55469 12.1152 8.31055 13.0879 8.31055ZM11.7109 16.1562C11.7109 15.832 11.7988 15.5859 11.9746 15.418C12.1504 15.25 12.4023 15.166 12.7305 15.166C13.0625 15.166 13.3164 15.252 13.4922 15.4238C13.6719 15.5957 13.7617 15.8398 13.7617 16.1562C13.7617 16.4688 13.6699 16.7148 13.4863 16.8945C13.3066 17.0703 13.0547 17.1582 12.7305 17.1582C12.4102 17.1582 12.1602 17.0723 11.9805 16.9004C11.8008 16.7246 11.7109 16.4766 11.7109 16.1562Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.fc0c4d82afa3721de7a655f770d7b7b2.svg";
export { ForwardRef as ReactComponent };